import Login from '../views/Login.vue'
import NotFound from '../views/404.vue'
import Home from '../views/Home.vue'
import ContributeMoney from '../views/nav1/ContributeMoney.vue'
import Volunteer from '../views/nav1/Volunteer.vue'


let routes = [{
    path: '/login',
    component: Login,
    name: '',
    hidden: true
},

{
    path: '/',
    component: Login,
    name: '',
    hidden: true
},
{
    path: '/404',
    component: NotFound,
    name: '',
    hidden: true
},
//{ path: '/main', component: Main },
{
    path: '/home',
    component: Home,
    name: '捐献管理',
    iconCls: 'el-icon-message', //图标样式class
    children: [
        {
            path: '/contributeMoney',
            component: ContributeMoney,
            name: '捐款列表'
        }
        ,
        {
            path: '/volunteer',
            component: Volunteer,
            name: '志愿者服务'
        }


    ]
},
{
    path: '/ClassRoom',
    component: Home,
    name: '微课堂',
    iconCls: 'el-icon-message', //图标样式class
    children: [
        {
            path: '/Study',
            component:() => import('@/views/ClassRoom/Study.vue'),
            name: '掌上学'
        }
        ,
        {
            path: '/Pulpit',
            component:() => import('@/views/ClassRoom/Pulpit.vue'),
            name: '博爱讲坛'
        }
        ,
        {
            path: '/Rule',
            component:() => import('@/views/ClassRoom/Rule.vue'),
            name: '政策法规'
        }

    ]
},
{
    path: '*',
    hidden: true,
    redirect: {
        path: '/404'
    }
}
];

export default routes;